import { useSelector } from 'react-redux'

import {
  bannerFlashMessagesSelector,
} from '@/selectors'

import FlashMessage from '../FlashMessage'

const Banners = () => {
  const banners = useSelector(bannerFlashMessagesSelector)
  const isShowing = banners.length > 0

  return (
    <If condition={isShowing}>
      <div aria-live="polite" id="flash-messages">
        {
          banners.map((message, index) => (
            <FlashMessage key={index} message={message} />
          ))
        }
      </div>
    </If>
  )
}

export default Banners
